import Vue from 'vue'
import VueTk from '@moke/vue-tk'
import store from '../store/index'
export default async () => {
  const { data: resExchange } = await VueTk.tkParse.get('/settings/isShowExchange').catch(() => {
    return { data: 'false' }
  })
  store.commit('setShowExchange', resExchange === 'true' || resExchange === true)
  // 用户自动登录
  if (!store.state.sessionToken) {
    return
  }
  VueTk.tkParse.setSessionToken(store.state.sessionToken)
  Vue.prototype.$cloudAjax.config.headers = {
    'X-Parse-Session-Token': store.state.sessionToken
  }
  let user = await VueTk.tkParse.getData('/users/me').catch(() => {
    store.commit('setSessionToken', null)
    store.commit('setUser', null)
    VueTk.tkParse.setSessionToken('')
  })
  if (!user) return
  store.commit('setUser', user)
  store.commit('setSessionToken', store.state.sessionToken)

  const { data: res } = await VueTk.tkParse.get('/settings/isRecordProgress').catch(() => {
    return { data: 'false' }
  })
  store.commit('setProgress', res === 'true' || res === true)
}
